import React from "react";
import PropTypes from "prop-types";
import "../style/Text.scss";

const Text = (props) => {
  const { text, className, bg } = props;
  return (
    <div className="text-block">
      <p
        className={`
            body-text
            font-copy
            color-gray-darkest
            pb-md
            ${className}`}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
};

Text.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

Text.defaultProps = {
  text: "This is what a story paragraph looks like in the template. It matches site style and sizes on desktop and mobile.",
  className: "",
};

export default Text;
